/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ obj: NonNullable<unknown> }} Heating_Curve_Auto_DescriptionInputs */



/**
* | output |
* | --- |
* | "Daily adaptation of the heating curve based on the average temperature rise speed of the thermostatic valves. If the target is not achieved ({obj}min/°C), th..." |
*
* @param {Heating_Curve_Auto_DescriptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const heating_curve_auto_description = /** @type {((inputs: Heating_Curve_Auto_DescriptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Heating_Curve_Auto_DescriptionInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Daily adaptation of the heating curve based on the average temperature rise speed of the thermostatic valves.
If the target is not achieved (${i?.obj}min/°C), the system will adapt the heating curve. The adaptation is bounded by a maximum`)
	return /** @type {LocalizedString} */ (`Adaptation quotidienne de la loi d'eau en fonction de la vitesse de montée en température moyenne des têtes th.
Si l'objectif n'est pas atteint (${i?.obj}min/°C), le système va adapter la loi d'eau. L'adaptation est bornée par un maximum`)
});